import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeader: {
		id: 'project-create-importer-upload-flow.common.import-error-message.error-header',
		defaultMessage: 'We couldn’t begin the import',
		description: 'Title of error occurred when start import',
	},
	errorDescription: {
		id: 'project-create-importer-upload-flow.common.import-error-message.error-description',
		defaultMessage: 'Select Import to try again.',
		description: 'Description of error occurred when start import',
	},
});
